import React from 'react'
import { useTranslation } from 'react-i18next'


export enum LocalDTFormater {
    LocalDateShort = "local_date_short",
    LocalDate = "local_date",
    LocalDay = "local_day",
    LocalMonth = "local_month",
}

export const useTranslatedCurrentDate = () => {
    const { t } = useTranslation()

    let date = new Date()
    return t(LocalDTFormater.LocalDateShort, { date }).toString()
}

export const getTranslation = ({ children, prefix }: { children: string; prefix?: string }) => {
    const { t } = useTranslation()
    return t(prefix ? `${prefix}.${children}` : children).toString()
}

export const Gt: React.FC<{ children: string; prefix?: string }> = ({ children, prefix }) => {
    const { t } = useTranslation()
    return <>{t(prefix ? `${prefix}.${children}` : children)}</>
}

export const GtCurrency: React.FC<{ children: string | number, currency?: string }> = ({ children, currency = 'JPY' }) => {
    const { i18n } = useTranslation()
    const value = typeof children === 'string' ? parseFloat(children) : children
    if (isNaN(value)) return <>{children}</>
    const formatted = new Intl.NumberFormat(i18n.language, {
        style: 'currency',
        currency,
    }).format(value)
    return <>{formatted}</>
}

export const GtDatetime: React.FC<{ children: string, template?: string  }> = ({ children, template }) => {
    const { t } = useTranslation()

    let date = new Date()
    try {
        date = new Date(children)
    } catch (e) {
        console.error(e)
    }

    if (!template) template = LocalDTFormater.LocalDateShort
    return <>{t(template, { date })}</>
}
